import { render, staticRenderFns } from "./EventInfoPlaceAddress.vue?vue&type=template&id=ff6494d8&scoped=true&"
import script from "./EventInfoPlaceAddress.vue?vue&type=script&lang=ts&"
export * from "./EventInfoPlaceAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6494d8",
  null
  
)

export default component.exports